module.exports = __webpack_public_path__ + "img/sudoku.4ad8e92c.png";